import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faArchive, faCommentQuestion, faDownload, faInfoCircle, faSave, faWarning, faXmark } from '@fortawesome/pro-regular-svg-icons';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import React from 'react';
import { VoxelButtonColor } from '../../../components/voxel/Buttons/VoxelButton';
import VoxelPanel from '../../../components/voxel/Surfaces/VoxelPanel';
import VoxelText from '../../../components/voxel/Text/VoxelText';
import IconButtonSection from './IconButtonSection';
import SquareButtonSection from './SquareButtonSection';


export interface ButtonsBoardProps { }

export interface ButtonItem {
  title: string;
  color: VoxelButtonColor;
  icon: IconProp | null;
};

export const buttonColorIconList: ButtonItem[] = [
  { title: 'Cancel', color: 'white', icon: faInfoCircle },
  { title: 'Cancel', color: 'transparent', icon: faCommentQuestion },
  { title: 'Add new', color: 'primary', icon: faPlus },
  { title: 'Save draft', color: 'indigo', icon: faSave },
  { title: 'Archive', color: 'light-gray', icon: faArchive },
  { title: 'Download', color: 'gray', icon: faDownload },
  { title: 'Save', color: 'success', icon: faSave },
  { title: 'Update', color: 'warning', icon: faWarning },
  { title: 'Delete', color: 'error', icon: faXmark },
];

export const buttonSizesList: ButtonItem[] = [
  { title: 'Archive', color: 'light-gray', icon: faArchive },
  { title: 'Download', color: 'gray', icon: faDownload },
];

export const ButtonsBoard: React.FC<ButtonsBoardProps> = ({ }) => {

  return (
    <div className="flex flex-row gap-12">
      <VoxelPanel className='p-6 basis-1/2'>
        <VoxelText variant='title2' paddingBot>Buttons</VoxelText>
        <SquareButtonSection />
      </VoxelPanel>
      <VoxelPanel className='p-6 basis-1/2'>
        <VoxelText variant='title2' paddingBot>Icon buttons</VoxelText>
        <IconButtonSection />
      </VoxelPanel>
    </div>
  );
};

export default ButtonsBoard;
